import { t } from './i18n'
import { JoinPage } from './JoinPage'
import { takeJoinCodeFromFragment } from './route'
import { StatusScreen } from './StatusScreen'
import { loadReconnect } from './session-store'

// Captured at module load, exactly once, BEFORE React renders. The fragment
// scrubber is side-effecting, and StrictMode double-invokes render-phase
// initializers in development — a useState(initializer) here would read an
// already-scrubbed hash on the second call and lose the code.
const initialCode: string | null = takeJoinCodeFromFragment()
const initialReconnect = loadReconnect()

export function App() {
  const code = initialCode
  const reconnect = initialReconnect

  if (!code && !reconnect) {
    return <StatusScreen title={t('boot.noLink.title')} detail={t('boot.noLink.detail')} />
  }

  return <JoinPage code={code} savedReconnect={reconnect} />
}
